export const envFlag = (value, defaultValue = false) => {
  if (value === undefined || value === null || value === '') return defaultValue;

  const v = String(value).trim().toLowerCase();

  if (['true', '1', 'yes', 'y', 'on'].includes(v)) return true;
  if (['false', '0', 'no', 'n', 'off'].includes(v)) return false;

  return defaultValue;
}
